import { Check, X } from "lucide-react";

import { Checkbox } from "@/components/ui/checkbox";
import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import TagList from "components/TagList";
import { SELECT_COLUMN_ID } from "constants/Constants";
import { invalidateEmailUrlsTableQuery } from "hooks/useEmailUrlsTable";
import { EMAIL_URLS_TABLE_CONSTANTS } from "routes/email_urls/components/email_urls_table/EmailUrlsTableV3";
import { EmailUrlsTableActions } from "routes/email_urls/components/email_urls_table/EmailUrlsTableActions";

const renderAutoTags = (tags, emailUrlId, prefix) => (
  <ScrollColumn>
    {(tags ?? []).map(tag => (
      <li key={`${prefix}-${emailUrlId}-${tag.id}`}>{tag.name}</li>
    ))}
  </ScrollColumn>
);

export const getEmailUrlsTableColumns = () => {
  return [
    {
      id: SELECT_COLUMN_ID,
      size: 60,
      enableSorting: false,
      meta: {
        isDisplay: true,
      },
      header: ({ table }) => (
        <Checkbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onCheckedChange: checked => table.toggleAllRowsSelected(!!checked),
            "aria-label": "Select all rows",
          }}
        />
      ),
      cell: ({ row }) => (
        <div>
          <Checkbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected() && !row.getIsSelected(),
              onCheckedChange: checked => row.toggleSelected(!!checked),
              "aria-label": "Select row",
            }}
          />
        </div>
      ),
    },
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Tags",
      id: "Tags",
      accessorKey: "tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.original.tags}
          modelType={EMAIL_URLS_TABLE_CONSTANTS.className}
          modelId={row.original.id}
          tableCell
          onUpdate={invalidateEmailUrlsTableQuery}
        />
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "URL",
      id: "URL",
      accessorKey: "url",
    },
    {
      header: "Is Form",
      id: "Is Form",
      accessorKey: "is_form",
      cell: ({ row }) =>
        row.original?.is_form ? (
          <Check className="tw:size-4 tw:text-success" aria-label="Form" />
        ) : (
          <X
            className="tw:size-4 tw:text-destructive"
            aria-label="Not a form"
          />
        ),
    },
    {
      header: "Language",
      id: "Language",
      accessorKey: "language",
    },
    {
      header: "Entity Tags",
      id: "Entity Tags",
      accessorKey: "entity_auto_tags",
      enableSorting: false,
      cell: ({ row }) =>
        renderAutoTags(
          row.original?.entity_auto_tags,
          row.original?.id,
          "entity-tag"
        ),
    },
    {
      header: "Contact Tags",
      id: "Contact Tags",
      accessorKey: "contact_auto_tags",
      enableSorting: false,
      cell: ({ row }) =>
        renderAutoTags(
          row.original?.contact_auto_tags,
          row.original?.id,
          "contact-tag"
        ),
    },
    {
      header: "Notify Email",
      id: "Notify Email",
      accessorKey: "notify_email",
      enableSorting: false,
    },
    {
      header: "Clicky ID",
      id: "Clicky ID",
      accessorKey: "clicky_id",
    },
    {
      header: "Clicky Key",
      id: "Clicky Key",
      accessorKey: "clicky_key",
    },
    {
      header: "Active",
      id: "Active",
      accessorKey: "active",
      cell: ({ row }) =>
        row.original?.active ? (
          <Check className="tw:size-4 tw:text-success" aria-label="Active" />
        ) : (
          <X className="tw:size-4 tw:text-destructive" aria-label="Inactive" />
        ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <EmailUrlsTableActions original={row.original} />,
    },
  ];
};

export const getEmailUrlsTableFilters = ({ tags }) => {
  return [
    {
      key: "tag_id",
      title: "Tag",
      type: "tag",
      data: tags,
    },
  ];
};
